module.exports = __webpack_public_path__ + "img/liechtenstein.299eba5f.svg";